import { render } from "./ComponentePrecios.vue?vue&type=template&id=38d75e19&scoped=true"
import script from "./ComponentePrecios.vue?vue&type=script&lang=js"
export * from "./ComponentePrecios.vue?vue&type=script&lang=js"

import "./ComponentePrecios.vue?vue&type=style&index=0&id=38d75e19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d75e19"]])

export default __exports__